// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "j") return "static/css/j.18dcef18.css";
if (chunkId === "d") return "static/css/d.5eebecb7.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}